import React from 'react';

import propTypes from 'propTypes';
import OrderSummaryRow from './OrderSummaryRow';
import PriceSpan from 'common/components/formatters/PriceSpan';
import { TranslatedMessage } from 'common/components/Intl';

export default class OrderSummary extends React.Component {
  static propTypes = {
    subtotalCents: propTypes.number.isRequired,
    shippingCost: propTypes.number.isRequired,
    itemQuantity: propTypes.number.isRequired,
    totalSavings: propTypes.number.isRequired,
  };

  render() {
    const { subtotalCents, shippingCost, totalSavings } = this.props;
    const subtotalComponent = <PriceSpan cents={subtotalCents} />;

    const shippingCostValue =
      shippingCost === 0 ? 'Free' : <PriceSpan cents={shippingCost} />;

    let savingsItem;
    if (totalSavings > 0) {
      const contents = <PriceSpan amount={totalSavings} />;
      savingsItem = (
        <OrderSummaryRow color="green" label="Savings" value={contents} />
      );
    }

    return (
      <div className="CartSidebar__order-summary">
        <OrderSummaryRow
          label={<TranslatedMessage id={'cart.order_summary.subtotal'} />}
          value={subtotalComponent}
        />
        <OrderSummaryRow
          label={<TranslatedMessage id={'cart.order_summary.shipping'} />}
          value={shippingCostValue}
        />
        <OrderSummaryRow
          label={<TranslatedMessage id={'cart.order_summary.tax'} />}
          value={<TranslatedMessage id={'cart.order_summary.tbd'} />}
          extraClasses="is-taxes"
        />
        {savingsItem}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/sidebar/OrderSummary.js